// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__CIzfo"};